// 'success' 'error' 'warning' 'info'
export default {
  CONFIRM: 'confirm',
  CLEAR: 'clear',
};
